import request from '@/utils/request';
const baseURL = process.env.VUE_APP_COS_API;
// 获取临时密钥
export const getCosTmpApi = data => {
  console.log(baseURL, 'baseURL');
  return request({
    url: `/temp-secret-v2`,
    params: {
      ...data
    },
    baseURL,
    method: 'get'
  });
};
